import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AgeService } from './age.service';

@Injectable({
  providedIn: 'root'
})
export class AgeGuard implements CanActivate {
  constructor(private age: AgeService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      var selectedDate = this.age.birthdate;
      if (!selectedDate)
        return false;

      return this.age.beeAge > 0;
  }
  
}
